<template>
  <div class="flex-col p-20 border border-gray-50 rounded-8 m-8">
    <div class="text-16 font-bold">Whitelabeling</div>
    <div class="flex-col text-gray-500 text-13" v-if="!whitelabeling">
      Please contact
      <a href="mailto:support@3dspark.de" class="text-primary-500 hover:underline">support@3dspark.de</a> to enable your
      custom color settings and logo.
    </div>
    <div class="flex-col" v-else>
      <LogoSettings />
      <ColorSettings />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ColorSettings from './ColorSettings.vue';
import LogoSettings from './LogoSettings.vue';

export default {
  name: 'WhitelabelingSettings',

  components: { ColorSettings, LogoSettings },

  computed: {
    ...mapState(['organization']),

    whitelabeling() {
      return this.organization.allow_white_label;
    },
  },
};
</script>
